// src/styles/global.tokens.ts
var stylesTokensCore = {
  "--em-core-border-radius--000": "0rem",
  "--em-core-border-radius--050": "0.125rem",
  "--em-core-border-radius--100": "0.25rem",
  "--em-core-border-radius--150": "0.375rem",
  "--em-core-border-radius--200": "0.5rem",
  "--em-core-border-radius--300": "0.75rem",
  "--em-core-border-radius--400": "2rem",
  "--em-core-border-radius--500": "624.9375rem",
  "--em-core-border-width--000": "0rem",
  "--em-core-border-width--025": "0.0625rem",
  "--em-core-border-width--050": "0.125rem",
  "--em-core-border-width--100": "0.25rem",
  "--em-core-color-gray--0000": "#ffffff",
  "--em-core-color-gray--0050": "#f7f7f8",
  "--em-core-color-gray--0100": "#ededf1",
  "--em-core-color-gray--0200": "#e4e4ea",
  "--em-core-color-gray--0300": "#d2d2d5",
  "--em-core-color-gray--0400": "#b8b8bd",
  "--em-core-color-gray--0500": "#909098",
  "--em-core-color-gray--0600": "#727279",
  "--em-core-color-gray--0700": "#5c5c66",
  "--em-core-color-gray--0800": "#31313d",
  "--em-core-color-gray--0900": "#212129",
  "--em-core-color-gray--1000": "#000000",
  "--em-core-font-family--base": "'inter'",
  "--em-core-font-family--code": "monospace",
  "--em-core-font-size--md": "1rem",
  "--em-core-font-size--sm": "0.875rem",
  "--em-core-font-size--xl": "1.25rem",
  "--em-core-font-size--xs": "0.75rem",
  "--em-core-font-size--xxl": "2rem",
  "--em-core-font-weight--bold": "700",
  "--em-core-font-weight--medium": "500",
  "--em-core-font-weight--regular": "400",
  "--em-core-line-height--l": "1.1875rem",
  "--em-core-line-height--md": "1rem",
  "--em-core-line-height--sm": "0.875rem",
  "--em-core-line-height--xl": "2.375rem",
  "--em-core-motion-duration--fast": "120ms",
  "--em-core-motion-duration--medium": "200ms",
  "--em-core-motion-duration--slow": "320ms",
  "--em-core-motion-easing--standard": "ease",
  "--em-core-motion-easing--linear": "linear",
  "--em-core-motion-easing--in-out": "ease-in-out",
  "--em-core-shadow-blur": "2.5rem",
  "--em-core-shadow-color": "#21212940",
  "--em-core-shadow-position-x": "0rem",
  "--em-core-shadow-position-y": "0.0625rem",
  "--em-core-shadow-spread": "0rem",
  "--em-core-size--0000": "0rem",
  "--em-core-size--0050": "0.125rem",
  "--em-core-size--0100": "0.25rem",
  "--em-core-size--0150": "0.375rem",
  "--em-core-size--0200": "0.5rem",
  "--em-core-size--0300": "0.75rem",
  "--em-core-size--0400": "1rem",
  "--em-core-size--0500": "1.25rem",
  "--em-core-size--0600": "1.5rem",
  "--em-core-size--0700": "1.75rem",
  "--em-core-size--0800": "2rem",
  "--em-core-size--0900": "2.25rem",
  "--em-core-size--1000": "2.5rem",
  "--em-core-size--1200": "3rem",
  "--em-core-size--1600": "4rem",
  "--em-core-size--2000": "5rem",
  "--em-core-spacing--0000": "0rem",
  "--em-core-spacing--0050": "0.125rem",
  "--em-core-spacing--0100": "0.25rem",
  "--em-core-spacing--0150": "0.375rem",
  "--em-core-spacing--0200": "0.5rem",
  "--em-core-spacing--0300": "0.75rem",
  "--em-core-spacing--0400": "1rem",
  "--em-core-spacing--0500": "1.25rem",
  "--em-core-spacing--0600": "1.5rem",
  "--em-core-spacing--0700": "1.75rem",
  "--em-core-spacing--0800": "2rem",
  "--em-core-spacing--0900": "2.25rem",
  "--em-core-spacing--1000": "2.5rem",
  "--em-core-spacing--1200": "3rem",
  "--em-core-spacing--1600": "4rem",
  "--em-core-spacing--2000": "5rem"
};
var stylesTokensSemantic = {
  "--em-sem-background": "var(--em-core-color-gray--0050)",
  "--em-sem-background--inverted": "var(--em-core-color-gray--0900)",
  "--em-sem-background--light": "var(--em-core-color-gray--0100)",
  "--em-sem-background--muted": "var(--em-core-color-gray--0300)",
  "--em-sem-background--neutral": "var(--em-core-color-gray--0000)",
  "--em-sem-background--subtle": "var(--em-core-color-gray--0200)",
  "--em-sem-chart-color--1": "#ff5400",
  "--em-sem-chart-color--10": "#8d99ae",
  "--em-sem-chart-color--2": "#3a86ff",
  "--em-sem-chart-color--3": "#ff8a00",
  "--em-sem-chart-color--4": "#ff2f6d",
  "--em-sem-chart-color--5": "#2ec4b6",
  "--em-sem-chart-color--6": "#6a4cff",
  "--em-sem-chart-color--7": "#8338ec",
  "--em-sem-chart-color--8": "#00b4d8",
  "--em-sem-chart-color--9": "#4caf50",
  "--em-sem-status-error-background": "#f6e2e2",
  "--em-sem-status-error-text": "#bc1010",
  "--em-sem-status-success-background": "#e1f0e9",
  "--em-sem-status-success-text": "#0f955a",
  "--em-sem-text": "var(--em-core-color-gray--0900)",
  "--em-sem-text--inverted": "var(--em-core-color-gray--0000)",
  "--em-sem-text--muted": "var(--em-core-color-gray--0700)",
  "--em-sem-text--neutral": "var(--em-core-color-gray--1000)",
  "--em-sem-text--subtle": "var(--em-core-color-gray--0400)"
};
var stylesTokensComponents = {
  "--em-actionicon-background": "var(--em-sem-background--light)",
  "--em-actionicon-background--active": "var(--em-sem-background--muted)",
  "--em-actionicon-background--hover": "var(--em-sem-background--subtle)",
  "--em-actionicon-border-color": "#ffffff00",
  "--em-actionicon-border-color--active": "#ffffff00",
  "--em-actionicon-border-color--disabled": "#ffffff00",
  "--em-actionicon-border-color--hover": "#ffffff00",
  "--em-actionicon-border-radius": "var(--em-core-border-radius--500)",
  "--em-actionicon-border-width": "0rem",
  "--em-actionicon-color": "var(--em-sem-text)",
  "--em-actionicon-color--disabled": "var(--em-sem-text--subtle)",
  "--em-actionicon-height": "var(--em-core-size--0800)",
  "--em-actionicon-icon-size": "var(--em-core-size--0400)",
  "--em-actionicon-width": "var(--em-core-size--0500)",
  "--em-barchart-border-radius": "var(--em-core-border-radius--150)",
  "--em-barchart-label-gap": "var(--em-core-spacing--0200)",
  "--em-button-background--disabled": "var(--em-sem-background--light)",
  "--em-button-background--primary": "var(--em-sem-text--muted)",
  "--em-button-background--primary--active": "var(--em-sem-text--neutral)",
  "--em-button-background--primary--hover": "var(--em-sem-text)",
  "--em-button-background--secondary": "var(--em-sem-background--light)",
  "--em-button-background--secondary--active": "var(--em-sem-background--muted)",
  "--em-button-background--secondary--hover": "var(--em-sem-background--subtle)",
  "--em-button-border-color--primary": "#ffffff00",
  "--em-button-border-color--primary--active": "#ffffff00",
  "--em-button-border-color--primary--disabled": "#ffffff00",
  "--em-button-border-color--primary--hover": "#ffffff00",
  "--em-button-border-color--secondary": "#ffffff00",
  "--em-button-border-color--secondary--active": "#ffffff00",
  "--em-button-border-color--secondary--disabled": "#ffffff00",
  "--em-button-border-color--secondary--hover": "#ffffff00",
  "--em-button-border-radius": "var(--em-core-border-radius--500)",
  "--em-button-border-width": "0rem",
  "--em-button-color--disabled": "var(--em-sem-text--subtle)",
  "--em-button-color--primary": "var(--em-sem-text--inverted)",
  "--em-button-color--secondary": "var(--em-sem-text)",
  "--em-button-font-family": "var(--em-core-font-family--base)",
  "--em-button-font-size--medium": "var(--em-core-font-size--sm)",
  "--em-button-font-size--small": "var(--em-core-font-size--xs)",
  "--em-button-font-weight--medium": "var(--em-core-font-weight--bold)",
  "--em-button-font-weight--small": "var(--em-core-font-weight--medium)",
  "--em-button-height--medium": "var(--em-core-size--1000)",
  "--em-button-height--small": "var(--em-core-size--0800)",
  "--em-button-icon-size": "var(--em-core-size--0400)",
  "--em-button-label-padding": "var(--em-core-spacing--0200)",
  "--em-button-line-height--medium": "var(--em-core-line-height--md)",
  "--em-button-line-height--small": "var(--em-core-line-height--sm)",
  "--em-button-padding-left-right--medium": "var(--em-core-spacing--0300)",
  "--em-button-padding-left-right--small": "var(--em-core-spacing--0150)",
  "--em-buttonicon-background--primary": "var(--em-sem-text--muted)",
  "--em-buttonicon-background--primary--active": "var(--em-sem-text--neutral)",
  "--em-buttonicon-background--primary--disabled": "var(--em-sem-background--light)",
  "--em-buttonicon-background--primary--hover": "var(--em-sem-text)",
  "--em-buttonicon-background--secondary": "var(--em-sem-background--light)",
  "--em-buttonicon-background--secondary--active": "var(--em-sem-background--muted)",
  "--em-buttonicon-background--secondary--disabled": "var(--em-sem-background--light)",
  "--em-buttonicon-background--secondary--hover": "var(--em-sem-background--subtle)",
  "--em-buttonicon-border-color--primary": "#ffffff00",
  "--em-buttonicon-border-color--primary--active": "#ffffff00",
  "--em-buttonicon-border-color--primary--disabled": "#ffffff00",
  "--em-buttonicon-border-color--primary--hover": "#ffffff00",
  "--em-buttonicon-border-color--secondary": "#ffffff00",
  "--em-buttonicon-border-color--secondary--active": "#ffffff00",
  "--em-buttonicon-border-color--secondary--disabled": "#ffffff00",
  "--em-buttonicon-border-color--secondary--hover": "#ffffff00",
  "--em-buttonicon-border-radius": "var(--em-core-border-radius--500)",
  "--em-buttonicon-border-width": "0rem",
  "--em-buttonicon-color--disabled": "var(--em-sem-text--subtle)",
  "--em-buttonicon-color--primary": "var(--em-sem-text--inverted)",
  "--em-buttonicon-color--secondary": "var(--em-sem-text)",
  "--em-buttonicon-height--medium": "var(--em-core-size--1000)",
  "--em-buttonicon-height--small": "var(--em-core-size--0800)",
  "--em-buttonicon-icon-size": "var(--em-core-size--0400)",
  "--em-buttonicon-width--medium": "var(--em-core-size--1000)",
  "--em-buttonicon-width--small": "var(--em-core-size--0800)",
  "--em-card-background": "var(--em-sem-background)",
  "--em-card-border-color": "#ffffff00",
  "--em-card-border-radius": "var(--em-core-border-radius--400)",
  "--em-card-border-width": "0rem",
  "--em-card-feedback-color--error": "var(--em-sem-status-error-text)",
  "--em-card-feedback-font-size": "var(--em-core-font-size--sm)",
  "--em-card-feedback-gap": "var(--em-core-spacing--0300)",
  "--em-card-feedback-icon-size": "var(--em-core-size--0400)",
  "--em-card-feedback-line-height": "var(--em-core-line-height--md)",
  "--em-card-feedback-padding-bottom": "var(--em-core-spacing--0800)",
  "--em-card-feedback-subtitle-color": "var(--em-sem-text--muted)",
  "--em-card-feedback-subtitle-font-weight": "var(--em-core-font-weight--regular)",
  "--em-card-feedback-title-color": "var(--em-sem-text)",
  "--em-card-feedback-title-font-weight": "var(--em-core-font-weight--medium)",
  "--em-card-font-family": "var(--em-core-font-family--base)",
  "--em-card-gap": "var(--em-core-spacing--0800)",
  "--em-card-gap--compact": "var(--em-core-spacing--0200)",
  "--em-card-header-gap": "var(--em-core-spacing--0400)",
  "--em-card-header-gap--compact": "var(--em-core-spacing--0100)",
  "--em-card-info-icon-color": "var(--em-sem-text)",
  "--em-card-info-icon-gap": "var(--em-core-spacing--0100)",
  "--em-card-info-icon-size": "var(--em-core-size--0400)",
  "--em-card-loader-background": "var(--em-sem-background--neutral)",
  "--em-card-loader-border-radius": "var(--em-core-border-radius--500)",
  "--em-card-loader-color": "var(--em-sem-text)",
  "--em-card-loader-padding": "var(--em-core-spacing--0100)",
  "--em-card-loader-size": "var(--em-core-size--0600)",
  "--em-card-padding": "var(--em-core-spacing--0800)",
  "--em-card-subtitle-color": "var(--em-sem-text--muted)",
  "--em-card-subtitle-font-size": "var(--em-core-font-size--sm)",
  "--em-card-subtitle-font-weight": "var(--em-core-font-weight--regular)",
  "--em-card-subtitle-line-height": "var(--em-core-line-height--l)",
  "--em-card-title-color": "var(--em-sem-text)",
  "--em-card-title-font-size": "var(--em-core-font-size--md)",
  "--em-card-title-font-weight": "var(--em-core-font-weight--bold)",
  "--em-card-title-line-height": "var(--em-core-line-height--l)",
  "--em-chart-category-color": "var(--em-sem-text--muted)",
  "--em-chart-category-font-family": "var(--em-core-font-family--base)",
  "--em-chart-category-font-size": "var(--em-core-font-size--xs)",
  "--em-chart-category-font-weight": "var(--em-core-font-weight--medium)",
  "--em-chart-category-gap": "var(--em-core-spacing--0100)",
  "--em-chart-category-indicator-border-radius": "var(--em-core-border-radius--500)",
  "--em-chart-category-indicator-color": "var(--em-sem-chart-color--1)",
  "--em-chart-category-line-height": "var(--em-core-line-height--sm)",
  "--em-chart-category-list-gap": "var(--em-core-spacing--0400)",
  "--em-chart-category-size": "var(--em-core-size--0300)",
  "--em-chart-grid-font-family": "var(--em-core-font-family--base)",
  "--em-chart-grid-label-color": "var(--em-sem-text)",
  "--em-chart-grid-label-color--light": "var(--em-sem-background--light)",
  "--em-chart-grid-label-color--muted": "var(--em-sem-text--muted)",
  "--em-chart-grid-label-color--subtle": "var(--em-sem-text--subtle)",
  "--em-chart-grid-label-font-size": "var(--em-core-font-size--xs)",
  "--em-chart-grid-label-font-weight": "var(--em-core-font-weight--regular)",
  "--em-chart-grid-line-color": "var(--em-sem-text)",
  "--em-chart-grid-line-color--light": "var(--em-sem-background--light)",
  "--em-chart-grid-line-color--subtle": "var(--em-sem-text--subtle)",
  "--em-chart-grid-line-width--medium": "0.125rem",
  "--em-chart-grid-line-width--thick": "0.25rem",
  "--em-chart-grid-line-width--thin": "0.0625rem",
  "--em-chart-grid-tick-length": "var(--em-core-size--0100)",
  "--em-chart-grid-tick-width": "0.0625rem",
  "--em-chart-grid-title-font-size": "var(--em-core-font-size--sm)",
  "--em-chart-grid-title-font-weight": "var(--em-core-font-weight--bold)",
  "--em-chart-label-background": "var(--em-sem-background--neutral)",
  "--em-chart-label-border-radius": "var(--em-core-border-radius--500)",
  "--em-chart-label-color": "var(--em-sem-text)",
  "--em-chart-label-font-family": "var(--em-core-font-family--base)",
  "--em-chart-label-font-size": "var(--em-core-font-size--xs)",
  "--em-chart-label-font-weight": "var(--em-core-font-weight--medium)",
  "--em-chart-label-line-height": "var(--em-core-line-height--sm)",
  "--em-chart-label-padding-left-right": "var(--em-core-spacing--0100)",
  "--em-chart-label-padding-top-bottom": "var(--em-core-spacing--0050)",
  "--em-chart-selectfield-padding-bottom": "var(--em-core-spacing--0400)",
  "--em-chart-tabs-border-color--hover": "var(--em-core-color-gray--0200)",
  "--em-chart-tabs-border-color--selected": "var(--em-core-color-gray--0400)",
  "--em-chart-tabs-border-radius": "var(--em-core-border-radius--300)",
  "--em-chart-tabs-border-width": "var(--em-core-border-width--025)",
  "--em-chart-tabs-color": "var(--em-sem-text--neutral)",
  "--em-chart-tabs-font-family": "var(--em-core-font-family--base)",
  "--em-chart-tabs-gap": "var(--em-core-spacing--0200)",
  "--em-chart-tabs-padding": "var(--em-core-spacing--0300)",
  "--em-chart-tabs-pagination-padding": "var(--em-core-spacing--0100)",
  "--em-chart-tabs-title-font-size": "var(--em-core-font-size--xs)",
  "--em-chart-tabs-title-font-weight": "var(--em-core-font-weight--medium)",
  "--em-chart-tabs-title-line-height": "var(--em-core-line-height--sm)",
  "--em-chart-tabs-value-font-size": "var(--em-core-font-size--xl)",
  "--em-chart-tabs-value-font-weight": "var(--em-core-font-weight--medium)",
  "--em-chart-tabs-value-line-height": "var(--em-core-line-height--l)",
  "--em-chart-tooltip-background": "var(--em-sem-background--inverted)",
  "--em-chart-tooltip-border-radius": "var(--em-core-border-radius--300)",
  "--em-chart-tooltip-family": "var(--em-core-font-family--base)",
  "--em-chart-tooltip-gap": "var(--em-core-spacing--0200)",
  "--em-chart-tooltip-padding": "var(--em-core-spacing--0400)",
  "--em-chart-tooltip-title-color": "var(--em-sem-text--inverted)",
  "--em-chart-tooltip-title-font-size": "var(--em-core-font-size--sm)",
  "--em-chart-tooltip-title-font-weight": "var(--em-core-font-weight--bold)",
  "--em-chart-tooltip-title-line-height": "var(--em-core-line-height--md)",
  "--em-daterangepicker-accent-color": "var(--em-sem-background--inverted)",
  "--em-daterangepicker-chevron--active": "var(--em-sem-background--muted)",
  "--em-daterangepicker-chevron--hover": "var(--em-sem-background--subtle)",
  "--em-daterangepicker-chevron-background": "var(--em-sem-background--light)",
  "--em-daterangepicker-chevron-border-radius": "var(--em-core-border-radius--200)",
  "--em-daterangepicker-chevron-color": "var(--em-sem-text)",
  "--em-daterangepicker-chevron-icon-size": "var(--em-core-size--0400)",
  "--em-daterangepicker-chevron-size": "var(--em-core-size--0800)",
  "--em-daterangepicker-day-color": "var(--em-sem-text)",
  "--em-daterangepicker-day-font-family": "var(--em-core-font-family--base)",
  "--em-daterangepicker-day-font-size": "var(--em-core-font-size--sm)",
  "--em-daterangepicker-day-font-weight": "var(--em-core-font-weight--medium)",
  "--em-daterangepicker-day-outside": "var(--em-sem-text--subtle)",
  "--em-daterangepicker-day-range-background": "var(--em-sem-background--light)",
  "--em-daterangepicker-day-range-limit-border-radius": "var(--em-core-border-radius--200)",
  "--em-daterangepicker-day-range-limit-color": "var(--em-sem-text--inverted)",
  "--em-daterangepicker-day-size": "var(--em-core-size--0800)",
  "--em-daterangepicker-label-color": "var(--em-sem-text)",
  "--em-daterangepicker-label-font-family": "var(--em-core-font-family--base)",
  "--em-daterangepicker-label-font-size": "var(--em-core-font-size--sm)",
  "--em-daterangepicker-label-font-weight": "var(--em-core-font-weight--medium)",
  "--em-daterangepicker-table-padding-top": "var(--em-core-spacing--0200)",
  "--em-daterangepicker-weekday-color": "var(--em-sem-text--muted)",
  "--em-daterangepicker-weekday-font-family": "var(--em-core-font-family--base)",
  "--em-daterangepicker-weekday-font-size": "var(--em-core-font-size--sm)",
  "--em-daterangepicker-weekday-font-weight": "var(--em-core-font-weight--medium)",
  "--em-divider-color": "var(--em-sem-background--subtle)",
  "--em-divider-thickness": "0.0625rem",
  "--em-field-feedback-color": "var(--em-sem-text--muted)",
  "--em-field-feedback-color--error": "var(--em-sem-status-error-text)",
  "--em-field-feedback-error-font-size": "var(--em-core-font-size--xs)",
  "--em-field-feedback-error-font-weight": "var(--em-core-font-weight--medium)",
  "--em-field-feedback-error-line-height": "var(--em-core-line-height--md)",
  "--em-field-feedback-font-size": "var(--em-core-font-size--xs)",
  "--em-field-feedback-font-weight": "var(--em-core-font-weight--regular)",
  "--em-field-feedback-line-height": "var(--em-core-line-height--sm)",
  "--em-field-feedback-padding-bottom": "var(--em-core-spacing--0200)",
  "--em-field-feedback-padding-top": "var(--em-core-spacing--0200)",
  "--em-field-font-family": "var(--em-core-font-family--base)",
  "--em-field-header-color": "var(--em-sem-text)",
  "--em-field-header-padding-bottom": "var(--em-core-spacing--0200)",
  "--em-field-header-required-font-size": "var(--em-core-font-size--xs)",
  "--em-field-header-required-font-weight": "var(--em-core-font-weight--regular)",
  "--em-field-header-required-line-height": "var(--em-core-line-height--sm)",
  "--em-field-header-title-font-size": "var(--em-core-font-size--sm)",
  "--em-field-header-title-font-weight": "var(--em-core-font-weight--medium)",
  "--em-field-header-title-line-height": "var(--em-core-line-height--md)",
  "--em-filter-background--chevron": "var(--em-sem-background--neutral)",
  "--em-filter-background--filter": "var(--em-sem-background--light)",
  "--em-filter-background--hover": "var(--em-sem-background--subtle)",
  "--em-filter-background--operator": "var(--em-core-color-gray--0050)",
  "--em-filter-background--selected": "var(--em-sem-background--muted)",
  "--em-filter-border-color": "#ffffff00",
  "--em-filter-border-color--hover": "#ffffff00",
  "--em-filter-border-color--operator": "#ffffff00",
  "--em-filter-border-color--selected": "#ffffff00",
  "--em-filter-border-radius": "var(--em-core-border-radius--100)",
  "--em-filter-border-radius--group": "var(--em-core-border-radius--400)",
  "--em-filter-border-width": "0rem",
  "--em-filter-color": "var(--em-sem-text--neutral)",
  "--em-filter-color--operator": "var(--em-sem-text--muted)",
  "--em-filter-gap--external": "var(--em-core-spacing--0300)",
  "--em-filter-gap--internal": "var(--em-core-spacing--0050)",
  "--em-filter-height": "var(--em-core-size--0800)",
  "--em-filter-label-font-family": "var(--em-core-font-family--base)",
  "--em-filter-label-font-size": "var(--em-core-font-size--xs)",
  "--em-filter-label-font-weight": "var(--em-core-font-weight--medium)",
  "--em-filter-label-font-weight--operator": "var(--em-core-font-weight--regular)",
  "--em-filter-label-label-padding-left-right": "var(--em-core-spacing--0150)",
  "--em-filter-label-line-height": "var(--em-core-line-height--sm)",
  "--em-filter-padding-left-right": "var(--em-core-spacing--0300)",
  "--em-filter-padding-left-right--operator": "var(--em-core-spacing--0100)",
  "--em-ghostbutton-background--active": "var(--em-sem-background--subtle)",
  "--em-ghostbutton-background--hover": "var(--em-sem-background--light)",
  "--em-ghostbutton-border-color": "#ffffff00",
  "--em-ghostbutton-border-color--active": "#ffffff00",
  "--em-ghostbutton-border-color--disabled": "#ffffff00",
  "--em-ghostbutton-border-color--hover": "#ffffff00",
  "--em-ghostbutton-border-radius": "var(--em-core-border-radius--100)",
  "--em-ghostbutton-border-width": "0rem",
  "--em-ghostbutton-color": "var(--em-sem-text)",
  "--em-ghostbutton-color--disabled": "var(--em-sem-text--subtle)",
  "--em-ghostbutton-font-family": "var(--em-core-font-family--base)",
  "--em-ghostbutton-font-size": "var(--em-core-font-size--xs)",
  "--em-ghostbutton-font-weight": "var(--em-core-font-weight--regular)",
  "--em-ghostbutton-height": "var(--em-core-size--0500)",
  "--em-ghostbutton-icon-size": "var(--em-core-size--0400)",
  "--em-ghostbutton-label-padding-left": "var(--em-core-spacing--0100)",
  "--em-ghostbutton-label-padding-right": "var(--em-core-spacing--0100)",
  "--em-ghostbutton-line-height": "var(--em-core-line-height--sm)",
  "--em-ghostbutton-padding-left-right": "var(--em-core-spacing--0050)",
  "--em-ghostbuttonicon-background--active": "var(--em-sem-background--subtle)",
  "--em-ghostbuttonicon-background--hover": "var(--em-sem-background--light)",
  "--em-ghostbuttonicon-border-color": "#ffffff00",
  "--em-ghostbuttonicon-border-color--active": "#ffffff00",
  "--em-ghostbuttonicon-border-color--disabled": "#ffffff00",
  "--em-ghostbuttonicon-border-color--hover": "#ffffff00",
  "--em-ghostbuttonicon-border-radius": "var(--em-core-border-radius--100)",
  "--em-ghostbuttonicon-border-width": "0rem",
  "--em-ghostbuttonicon-color": "var(--em-sem-text)",
  "--em-ghostbuttonicon-color--disabled": "var(--em-sem-text--subtle)",
  "--em-ghostbuttonicon-height": "var(--em-core-size--0500)",
  "--em-ghostbuttonicon-icon-size": "var(--em-core-size--0400)",
  "--em-ghostbuttonicon-width": "var(--em-core-size--0500)",
  "--em-kpichart-color": "var(--em-sem-text)",
  "--em-kpichart-font-family": "var(--em-core-font-family--base)",
  "--em-kpichart-gap": "var(--em-core-spacing--0400)",
  "--em-kpichart-label-color": "var(--em-sem-text)",
  "--em-kpichart-label-font-size": "var(--em-core-font-size--sm)",
  "--em-kpichart-label-font-weight": "var(--em-core-font-weight--regular)",
  "--em-kpichart-label-gap": "var(--em-core-spacing--0200)",
  "--em-kpichart-number-font-size": "var(--em-core-font-size--xxl)",
  "--em-kpichart-number-font-size--min": "0.75rem",
  "--em-kpichart-number-font-size--max": "62.4375rem",
  "--em-kpichart-number-font-weight": "var(--em-core-font-weight--bold)",
  "--em-kpichart-number-line-height": "var(--em-core-line-height--xl)",
  "--em-kpichart-trend-background--negative": "var(--em-sem-status-error-background)",
  "--em-kpichart-trend-background--positive": "var(--em-sem-status-success-background)",
  "--em-kpichart-trend-border-radius": "var(--em-core-border-radius--150)",
  "--em-kpichart-trend-color--negative": "var(--em-sem-status-error-text)",
  "--em-kpichart-trend-color--positive": "var(--em-sem-status-success-text)",
  "--em-kpichart-trend-font-size": "var(--em-core-font-size--md)",
  "--em-kpichart-trend-font-weight": "var(--em-core-font-weight--medium)",
  "--em-kpichart-trend-height": "var(--em-core-size--0600)",
  "--em-kpichart-trend-icon-size": "var(--em-core-size--0400)",
  "--em-kpichart-trend-line-height": "var(--em-core-line-height--md)",
  "--em-kpichart-trend-padding": "var(--em-core-spacing--0100)",
  "--em-linechart-line-dash": "var(--em-core-size--0100)",
  "--em-linechart-line-gap": "var(--em-core-size--0100)",
  "--em-linechart-line-width": "0.125rem",
  "--em-linechart-point-size": "var(--em-core-size--0200)",
  "--em-linechart-point-size--hover": "var(--em-core-size--0300)",
  "--em-markdown-background": "var(--em-sem-background--neutral)",
  "--em-markdown-code-color": "var(--em-sem-text)",
  "--em-markdown-code-font-family": "var(--em-core-font-family--code)",
  "--em-markdown-code-font-size": "var(--em-core-font-size--sm)",
  "--em-markdown-code-font-weight--regular": "var(--em-core-font-weight--regular)",
  "--em-markdown-code-font-weight--strong": "var(--em-core-font-weight--bold)",
  "--em-markdown-code-line-height": "var(--em-core-line-height--md)",
  "--em-markdown-color--placeholder": "var(--em-sem-background--muted)",
  "--em-markdown-h1-color": "var(--em-sem-text)",
  "--em-markdown-h1-font-family": "var(--em-core-font-family--base)",
  "--em-markdown-h1-font-size": "var(--em-core-font-size--xxl)",
  "--em-markdown-h1-font-weight": "var(--em-core-font-weight--bold)",
  "--em-markdown-h1-line-height": "var(--em-core-line-height--xl)",
  "--em-markdown-h2-color": "var(--em-sem-text)",
  "--em-markdown-h2-font-family": "var(--em-core-font-family--base)",
  "--em-markdown-h2-font-size": "var(--em-core-font-size--xl)",
  "--em-markdown-h2-font-weight": "var(--em-core-font-weight--bold)",
  "--em-markdown-h2-line-height": "var(--em-core-line-height--l)",
  "--em-markdown-h3-color": "var(--em-sem-text)",
  "--em-markdown-h3-font-family": "var(--em-core-font-family--base)",
  "--em-markdown-h3-font-size": "var(--em-core-font-size--md)",
  "--em-markdown-h3-font-weight": "var(--em-core-font-weight--bold)",
  "--em-markdown-h3-line-height": "var(--em-core-line-height--md)",
  "--em-markdown-hr-border-width": "0.0625rem",
  "--em-markdown-hr-color": "var(--em-sem-background--muted)",
  "--em-markdown-link-color": "var(--em-sem-text)",
  "--em-markdown-link-font-family": "var(--em-core-font-family--base)",
  "--em-markdown-link-font-size": "var(--em-core-font-size--sm)",
  "--em-markdown-link-font-weight": "var(--em-core-font-weight--medium)",
  "--em-markdown-link-line-height": "var(--em-core-line-height--md)",
  "--em-markdown-min-height": "10rem",
  "--em-markdown-options-border-color": "var(--em-sem-background--muted)",
  "--em-markdown-options-border-radius": "var(--em-core-border-radius--100)",
  "--em-markdown-options-border-width": "0.0625rem",
  "--em-markdown-options-gap": "var(--em-core-spacing--0100)",
  "--em-markdown-options-padding": "var(--em-core-spacing--0100)",
  "--em-markdown-p-color": "var(--em-sem-text)",
  "--em-markdown-p-font-family": "var(--em-core-font-family--base)",
  "--em-markdown-p-font-size": "var(--em-core-font-size--sm)",
  "--em-markdown-p-font-weight--regular": "var(--em-core-font-weight--regular)",
  "--em-markdown-p-font-weight--strong": "var(--em-core-font-weight--bold)",
  "--em-markdown-p-line-height": "var(--em-core-line-height--md)",
  "--em-markdown-placeholder-color": "var(--em-core-color-gray--0400)",
  "--em-overlay-background": "#212129e6",
  "--em-piechart-donut-color": "var(--em-sem-text)",
  "--em-piechart-donut-label-font-size": "var(--em-core-font-size--md)",
  "--em-piechart-donut-label-font-weight": "var(--em-core-font-weight--medium)",
  "--em-piechart-donut-label-line-height": "var(--em-core-line-height--md)",
  "--em-piechart-donut-number-font-size": "var(--em-core-font-size--xxl)",
  "--em-piechart-donut-number-font-weight": "var(--em-core-font-weight--bold)",
  "--em-piechart-donut-number-line-height": "var(--em-core-line-height--xl)",
  "--em-piechart-font-family": "var(--em-core-font-family--base)",
  "--em-selectfield-category-background": "var(--em-sem-background--subtle)",
  "--em-selectfield-category-border-radius": "var(--em-core-border-radius--150)",
  "--em-selectfield-category-color": "var(--em-sem-text--neutral)",
  "--em-selectfield-category-font-family": "var(--em-core-font-family--base)",
  "--em-selectfield-category-font-size": "var(--em-core-font-size--xs)",
  "--em-selectfield-category-font-weight": "var(--em-core-font-weight--bold)",
  "--em-selectfield-category-line-height": "var(--em-core-line-height--sm)",
  "--em-selectfield-category-padding": "var(--em-core-spacing--0100)",
  "--em-selectfield-content-background": "var(--em-sem-background--neutral)",
  "--em-selectfield-content-border-radius": "var(--em-core-border-radius--300)",
  "--em-selectfield-content-gap": "var(--em-core-spacing--0200)",
  "--em-selectfield-content-max-height": "20rem",
  "--em-selectfield-content-max-width": "25rem",
  "--em-selectfield-content-opacity--loading": "0.5",
  "--em-selectfield-content-padding": "var(--em-core-spacing--0200)",
  "--em-selectfield-content-shadow-blur": "var(--em-core-shadow-blur)",
  "--em-selectfield-content-shadow-color": "#21212940",
  "--em-selectfield-content-shadow-position-x": "var(--em-core-shadow-position-x)",
  "--em-selectfield-content-shadow-position-y": "var(--em-core-shadow-position-y)",
  "--em-selectfield-content-shadow-spread": "var(--em-core-shadow-spread)",
  "--em-selectfield-item-background": "var(--em-sem-background--neutral)",
  "--em-selectfield-item-background--active": "var(--em-sem-background--light)",
  "--em-selectfield-item-background--hover": "var(--em-sem-background)",
  "--em-selectfield-item-background--selected": "var(--em-sem-background--inverted)",
  "--em-selectfield-item-border-radius": "var(--em-core-border-radius--200)",
  "--em-selectfield-item-font-family": "var(--em-core-font-family--base)",
  "--em-selectfield-item-height": "var(--em-core-size--0800)",
  "--em-selectfield-item-icon-color": "var(--em-sem-text)",
  "--em-selectfield-item-icon-color--disabled": "var(--em-sem-text--subtle)",
  "--em-selectfield-item-icon-color--selected": "var(--em-sem-text--inverted)",
  "--em-selectfield-item-icon-size": "var(--em-core-size--0400)",
  "--em-selectfield-item-label-left-color": "var(--em-sem-text)",
  "--em-selectfield-item-label-left-color--disabled": "var(--em-sem-text--subtle)",
  "--em-selectfield-item-label-left-color--selected": "var(--em-sem-text--inverted)",
  "--em-selectfield-item-label-left-font-size": "var(--em-core-font-size--xs)",
  "--em-selectfield-item-label-left-font-weight": "var(--em-core-font-weight--medium)",
  "--em-selectfield-item-label-left-line-height": "var(--em-core-line-height--sm)",
  "--em-selectfield-item-label-padding-left-right": "var(--em-core-spacing--0200)",
  "--em-selectfield-item-label-right-color": "var(--em-sem-text--muted)",
  "--em-selectfield-item-label-right-color--disabled": "var(--em-sem-text--subtle)",
  "--em-selectfield-item-label-right-color--selected": "var(--em-sem-text--inverted)",
  "--em-selectfield-item-label-right-font-size": "var(--em-core-font-size--xs)",
  "--em-selectfield-item-label-right-font-weight": "var(--em-core-font-weight--regular)",
  "--em-selectfield-item-label-right-line-height": "var(--em-core-line-height--sm)",
  "--em-selectfield-item-padding": "var(--em-core-spacing--0200)",
  "--em-selectfield-trigger-background": "var(--em-sem-background--neutral)",
  "--em-selectfield-trigger-background--active": "var(--em-sem-background--light)",
  "--em-selectfield-trigger-background--filled": "var(--em-sem-background--inverted)",
  "--em-selectfield-trigger-background--hover": "var(--em-sem-background)",
  "--em-selectfield-trigger-border-color": "var(--em-sem-background--muted)",
  "--em-selectfield-trigger-border-color--error": "var(--em-sem-status-error-text)",
  "--em-selectfield-trigger-border-radius": "var(--em-core-border-radius--200)",
  "--em-selectfield-trigger-border-width": "var(--em-core-border-width--025)",
  "--em-selectfield-trigger-border-width--error": "var(--em-core-border-width--050)",
  "--em-selectfield-trigger-color": "var(--em-sem-text)",
  "--em-selectfield-trigger-color--disabled": "var(--em-sem-text--subtle)",
  "--em-selectfield-trigger-color--filled": "var(--em-sem-text--inverted)",
  "--em-selectfield-trigger-font-family": "var(--em-core-font-family--base)",
  "--em-selectfield-trigger-font-size": "var(--em-core-font-size--xs)",
  "--em-selectfield-trigger-font-weight": "var(--em-core-font-weight--medium)",
  "--em-selectfield-trigger-height": "var(--em-core-size--1000)",
  "--em-selectfield-trigger-icon-size": "var(--em-core-size--0400)",
  "--em-selectfield-trigger-label-padding-left-right": "var(--em-core-spacing--0200)",
  "--em-selectfield-trigger-line-height": "var(--em-core-line-height--sm)",
  "--em-selectfield-trigger-min-width": "4rem",
  "--em-selectfield-trigger-padding": "var(--em-core-spacing--0300)",
  "--em-skeleton-border-radius": "var(--em-core-border-radius--300)",
  "--em-switch-background--disabled": "var(--em-sem-background--subtle)",
  "--em-switch-background--off": "var(--em-sem-background--subtle)",
  "--em-switch-background--on": "var(--em-sem-background--inverted)",
  "--em-switch-font-family": "var(--em-core-font-family--base)",
  "--em-switch-height": "var(--em-core-size--0400)",
  "--em-switch-label-color": "var(--em-sem-text)",
  "--em-switch-label-color--disabled": "var(--em-sem-text--subtle)",
  "--em-switch-label-font-size": "var(--em-core-font-size--sm)",
  "--em-switch-label-font-weight": "var(--em-core-font-weight--medium)",
  "--em-switch-label-line-height": "var(--em-core-line-height--md)",
  "--em-switch-label-gap": "var(--em-core-spacing--0200)",
  "--em-switch-shadow-blur": "var(--em-core-shadow-blur)",
  "--em-switch-shadow-color": "var(--em-core-shadow-color)",
  "--em-switch-shadow-position-x": "var(--em-core-shadow-position-x)",
  "--em-switch-shadow-position-y": "var(--em-core-shadow-position-y)",
  "--em-switch-shadow-spread": "var(--em-core-shadow-spread)",
  "--em-switch-size-border-radius": "var(--em-core-border-radius--500)",
  "--em-switch-thumb-background": "var(--em-sem-background--neutral)",
  "--em-switch-thumb-background--disabled": "var(--em-sem-background--light)",
  "--em-switch-thumb-background--off": "var(--em-sem-text--muted)",
  "--em-switch-thumb-padding": "var(--em-core-spacing--0050)",
  "--em-switch-thumb-size": "var(--em-core-size--0300)",
  "--em-switch-width": "var(--em-core-size--0800)",
  "--em-tablechart-border-color": "var(--em-sem-background--light)",
  "--em-tablechart-border-radius": "var(--em-core-border-radius--300)",
  "--em-tablechart-border-width": "0.0625rem",
  "--em-tablechart-cell-background": "var(--em-sem-background--neutral)",
  "--em-tablechart-cell-background--hover": "var(--em-sem-background)",
  "--em-tablechart-cell-height": "var(--em-core-size--1000)",
  "--em-tablechart-cell-max-width": "calc(3 * var(--em-core-size--2000))",
  "--em-tablechart-cell-min-width": "var(--em-core-size--1200)",
  "--em-tablechart-cell-padding": "var(--em-core-spacing--0200)",
  "--em-tablechart-color": "var(--em-sem-text)",
  "--em-tablechart-color--muted": "var(--em-sem-text--muted)",
  "--em-tablechart-font-family": "var(--em-core-font-family--base)",
  "--em-tablechart-font-size": "var(--em-core-font-size--xs)",
  "--em-tablechart-font-weight": "var(--em-core-font-weight--regular)",
  "--em-tablechart-font-weight--bold": "var(--em-core-font-weight--bold)",
  "--em-tablechart-font-weight--medium": "var(--em-core-font-weight--medium)",
  "--em-tablechart-header-background": "var(--em-sem-background--neutral)",
  "--em-tablechart-header-background--hover": "var(--em-sem-background)",
  "--em-tablechart-heatmap-color": "var(--em-sem-chart-color--1)",
  "--em-tablechart-icon-size": "var(--em-core-size--0400)",
  "--em-tablechart-line-height": "var(--em-core-line-height--sm)",
  "--em-tablechart-loading-indicator-color": "var(--em-sem-text--neutral)",
  "--em-tablechart-loading-indicator-font-family": "var(--em-core-font-family--base)",
  "--em-tablechart-loading-indicator-font-size": "var(--em-core-font-size--xs)",
  "--em-tablechart-loading-indicator-font-weight": "var(--em-core-font-weight--bold)",
  "--em-tablechart-loading-indicator-padding": "var(--em-core-spacing--0300)",
  "--em-tablechart-padding-left-right": "var(--em-core-spacing--0100)",
  "--em-tablechart-pagination-button-gap": "var(--em-core-spacing--0200)",
  "--em-tablechart-pagination-height": "var(--em-core-size--1200)",
  "--em-tablechart-pagination-label-padding-left-right": "var(--em-core-spacing--0400)",
  "--em-tablechart-pivot-ident-padding": "var(--em-core-spacing--0400)",
  "--em-textfield-background": "var(--em-sem-background)",
  "--em-textfield-background--active": "var(--em-sem-background--subtle)",
  "--em-textfield-background--disabled": "var(--em-sem-background--neutral)",
  "--em-textfield-background--filled": "var(--em-sem-background--light)",
  "--em-textfield-border-color": "var(--em-sem-text--subtle)",
  "--em-textfield-border-color--error": "var(--em-sem-status-error-text)",
  "--em-textfield-border-radius": "var(--em-core-border-radius--200)",
  "--em-textfield-border-width": "var(--em-core-border-width--025)",
  "--em-textfield-border-width--error": "var(--em-core-border-width--050)",
  "--em-textfield-color": "var(--em-sem-text--muted)",
  "--em-textfield-color--disabled": "var(--em-sem-text--subtle)",
  "--em-textfield-color--filled": "var(--em-sem-text)",
  "--em-textfield-feedback-color": "var(--em-sem-text--muted)",
  "--em-textfield-feedback-color--error": "var(--em-sem-status-error-text)",
  "--em-textfield-feedback-font-family": "var(--em-core-font-family--base)",
  "--em-textfield-feedback-font-size": "var(--em-core-font-size--xs)",
  "--em-textfield-feedback-font-weight": "var(--em-core-font-weight--regular)",
  "--em-textfield-feedback-font-weight--error": "var(--em-core-font-weight--medium)",
  "--em-textfield-feedback-line-height": "var(--em-core-line-height--md)",
  "--em-textfield-font-family": "var(--em-core-font-family--base)",
  "--em-textfield-font-size": "var(--em-core-font-size--xs)",
  "--em-textfield-font-weight": "var(--em-core-font-weight--regular)",
  "--em-textfield-font-weight--filled": "var(--em-core-font-weight--medium)",
  "--em-textfield-height": "var(--em-core-size--1000)",
  "--em-textfield-icon-size": "var(--em-core-size--0400)",
  "--em-textfield-label-padding": "var(--em-core-spacing--0200)",
  "--em-textfield-line-height": "var(--em-core-line-height--md)",
  "--em-textfield-max-width": "25rem",
  "--em-textfield-min-width": "10rem",
  "--em-textfield-padding": "var(--em-core-spacing--0200)",
  "--em-tooltip-background": "var(--em-sem-background--inverted)",
  "--em-tooltip-border-radius": "var(--em-core-border-radius--150)",
  "--em-tooltip-color": "var(--em-sem-text--inverted)",
  "--em-tooltip-font-family": "var(--em-core-font-family--base)",
  "--em-tooltip-font-size": "var(--em-core-font-size--xs)",
  "--em-tooltip-font-weight": "var(--em-core-font-weight--regular)",
  "--em-tooltip-line-height": "var(--em-core-line-height--sm)",
  "--em-tooltip-max-width": "16rem",
  "--em-tooltip-padding-left-right": "var(--em-core-spacing--0200)",
  "--em-tooltip-padding-top-bottom": "var(--em-core-spacing--0150)",
  "--em-bubblechart-point-opacity": "0.7",
  "--em-bubblechart-point-opacity--null": "0.3",
  "--em-bubblechart-point-border-width": "var(--em-core-border-width--025, 0.0625rem)",
  "--em-bubblechart-point-radius--min": "5",
  "--em-bubblechart-point-radius--max": "40",
  "--em-bubblechart-point-radius--hover--scale": "1.2",
  "--em-scatterchart-point-opacity": "0.8",
  "--em-scatterchart-point-border-width": "var(--em-core-border-width--025, 0.0625rem)",
  "--em-scatterchart-point-radius": "var(--em-core-border-radius--150, 0.375rem)",
  "--em-scatterchart-point-radius--hover": "0.5rem",
  "--em-scatterchart-point-opacity--null": "0.3",
  "--em-scatterchart-label-stack-height": "1.25rem",
  "--em-scatterchart-label-stack-gap": "0.25rem",
  "--em-scatterchart-label-offset": "0.375rem",
  "--em-scatterchart-label-top-padding": "1.75rem",
  "--em-scatterchart-label-stroke-width": "3",
  "--em-charttabs-gap": "var(--em-core-spacing--0150)",
  "--em-charttabs-item-gap": "var(--em-core-spacing--0200)",
  "--em-charttabs-item-padding": "var(--em-core-spacing--0300)",
  "--em-charttabs-item-border-width": "var(--em-core-border-width--025)",
  "--em-charttabs-item-border-color": "transparent /* from remarkable-pro */",
  "--em-charttabs-item-border-radius": "var(--em-core-border-radius--300)",
  "--em-charttabs-item-opacity": "0.5 /* from remarkable-pro */",
  "--em-charttabs-item-border-color--hover": "var(--em-sem-text)",
  "--em-charttabs-item-background--hover": "#f7f7f8 /* from remarkable-pro */",
  "--em-charttabs-item-opacity--active": "1 /* from remarkable-pro */",
  "--em-charttabs-item-border-width--active": "var(--em-core-border-width--025)",
  "--em-charttabs-item-border-color--active": "var(--em-sem-text)",
  "--em-charttabs-item-label-color": "var(--em-sem-text)",
  "--em-charttabs-item-label-font-family": "var(--em-core-font-family--base)",
  "--em-charttabs-item-label-font-size": "var(--em-core-font-size--xs)",
  "--em-charttabs-item-label-font-weight": "var(--em-core-font-weight--medium)",
  "--em-charttabs-item-line-height": "var(--em-core-line-height--sm)",
  "--em-charttabs-item-value-color": "var(--em-sem-text)",
  "--em-charttabs-item-value-font-family": "var(--em-core-font-family--base)",
  "--em-charttabs-item-value-font-size": "var(--em-core-font-size--xl)",
  "--em-charttabs-item-value-font-weight": "var(--em-core-font-weight--medium)",
  "--em-charttabs-item-value-line-height": "var(--em-core-line-height--l)",
  "--em-charttabs-trend-gap": "var(--em-core-spacing--0100)",
  "--em-charttabs-trend-padding-x": "var(--em-core-spacing--0050)",
  "--em-charttabs-trend-border-radius": "var(--em-core-border-radius--150)",
  "--em-charttabs-trend-background--positive": "var(--em-sem-status-success-background)",
  "--em-charttabs-trend-color--positive": "var(--em-sem-status-success-text)",
  "--em-charttabs-trend-background--negative": "var(--em-sem-status-error-background)",
  "--em-charttabs-trend-color--negative": "var(--em-sem-status-error-text)",
  "--em-charttabs-trend-font-size": "var(--em-core-font-size--xs)",
  "--em-charttabs-trend-icon-size": "var(--em-core-size--0400)",
  "--em-charttabs-scroll-padding": "var(--em-core-spacing--0100)",
  "--em-charttabs-scroll-button-width": "1.75rem",
  "--em-canvas-overlay-position": "fixed",
  "--em-canvas-overlay-inset": "0",
  "--em-canvas-overlay-backdrop-background": "var(--em-overlay-background)",
  "--em-canvas-overlay-content-background": "transparent",
  "--em-canvas-overlay-width": "100%",
  "--em-canvas-overlay-max-width": "78rem",
  "--em-canvas-overlay-height": "auto",
  "--em-canvas-overlay-max-height": "none",
  "--em-canvas-overlay-padding": "0 2rem 2.25rem",
  "--em-canvas-overlay-border-radius": "1.75rem",
  "--em-canvas-overlay-title-color": "var(--em-sem-text--inverted)",
  "--em-canvas-overlay-action-button-color": "var(--em-buttonicon-color--secondary)",
  "--em-canvas-overlay-action-button-background": "var(--em-buttonicon-background--secondary)",
  "--em-canvas-overlay-action-button-border-color": "var(--em-buttonicon-border-color--secondary)",
  "--em-canvas-overlay-action-button-border-width": "var(--em-buttonicon-border-width)",
  "--em-canvas-overlay-action-button-border-radius": "var(--em-buttonicon-border-radius)",
  "--em-canvas-overlay-actions-justify-content": "center",
  "--em-canvas-overlay-actions-position": "sticky",
  "--em-canvas-overlay-actions-grid-column": "1 / 2",
  "--em-canvas-overlay-actions-grid-row": "2 / 3",
  "--em-canvas-overlay-actions-justify-self": "center",
  "--em-canvas-overlay-actions-align-self": "end",
  "--em-canvas-overlay-grid-template-columns": "repeat(3, minmax(22rem, 1fr))",
  "--em-canvas-overlay-grid-template-columns--tablet": "repeat(2, minmax(0, 1fr))",
  "--em-canvas-overlay-grid-template-columns--mobile": "1fr",
  "--em-canvas-overlay-grid-auto-rows": "var(--em-core-spacing--0200)",
  "--em-canvas-overlay-grid-auto-flow": "dense",
  "--em-canvas-overlay-grid-gap": "var(--em-core-spacing--0400)",
  "--em-canvas-overlay-grid-align-items": "start",
  "--em-canvas-overlay-configurator-grid-template-columns": "minmax(25rem, 30rem) 1fr",
  "--em-canvas-overlay-configurator-grid-template-columns--tablet": "1fr",
  "--em-canvas-overlay-configurator-grid-template-columns--mobile": "1fr",
  "--em-canvas-overlay-configurator-gap": "var(--em-core-spacing--0800)",
  "--em-canvas-overlay-configurator-form-background": "var(--em-sem-background--neutral)",
  "--em-canvas-overlay-configurator-form-padding": "var(--em-core-spacing--0800)",
  "--em-canvas-overlay-configurator-form-padding-bottom": "var(--em-core-spacing--2000)",
  "--em-canvas-overlay-configurator-form-border-radius": "var(--em-card-border-radius)",
  "--em-canvas-overlay-configurator-form-gap": "var(--em-core-spacing--0800)"
};

// src/styles/styles.constants.ts
var styles = {
  ...stylesTokensCore,
  ...stylesTokensSemantic,
  ...stylesTokensComponents
};

export {
  styles
};
//# sourceMappingURL=chunk-TSA7YIXI.js.map